import { styled } from '@mui/system';
import { Link } from 'react-router-dom';

export const LogoLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  userSelect: 'none',
  textDecoration: 'none',

  '& img': {
    width: 40,
  },

  '& .MuiTypography-root': {
    fontFamily: 'Poppins',
    textTransform: 'uppercase',
    fontSize: 24,
    color: 'white',
  },
});
